import React, { useState, useEffect } from 'react'

const AIServices = () => {
    const [activeService, setActiveService] = useState('consulting');

    useEffect(() => {
        // Add click event listeners to service tabs
        const tabs = document.querySelectorAll('.service-tab');
        const details = document.querySelectorAll('.service-detail');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const service = tab.getAttribute('data-service');

                // Remove active class from all tabs and details
                tabs.forEach(t => t.classList.remove('active'));
                details.forEach(d => d.classList.remove('active'));

                // Add active class to clicked tab and corresponding detail
                tab.classList.add('active');
                document.getElementById(service).classList.add('active');

                setActiveService(service);
            });
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <div className="breadcrumb-tagline">
                                    <span className="breadcrumb-line"></span>
                                    <span className="breadcrumb-text">INTELLIGENTLY DRIVE BUSINESS GROWTH</span>
                                </div> */}
                                <h1 className="breadcrumb-title">
                                    AI <span className="breadcrumb-highlight">Services</span>
                                </h1>
                                <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* AI-Driven Business Evolution Section */}
            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">AI development </span> Services
                                </h2>
                                <p className="ai-driven-description">
                                    Artificial intelligence (AI) consulting provides expert guidance to help businesses effectively adopt and integrate AI technologies into their operations. As an experienced AI consulting partner, CLOUD MIND X designs state-of-the-art, fully customized solutions aligned with each client’s unique needs, while accelerating AI development, optimizing project costs, and minimizing implementation risks.                                </p>
                                <button className="ai-driven-btn">
                                    <span>TALK TO AN EXPERT</span>
                                    <span className="ai-driven-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
                                    alt="AI-Driven Business Evolution"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How We Help Section */}
            <section className="how-we-help-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline">OUR EXPERTISE</span>
                                <h2 className="section-title" style={{ textAlign: 'center' }}>How We Help</h2>
                                <p className="text-muted lead m-0">
                                    With extensive experience in artificial intelligence and a team of 50+ IT professionals on board,<br />
                                    <span className="text-gradient">CLOUD MIND X</span> provides comprehensive assistance across AI implementation to help businesses<br />
                                    design, develop, and seamlessly maintain cutting-edge AI solutions.                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="row align-items-start">
                        {/* Left Side - Services Menu */}
                        <div className="col-lg-5">
                            <div className="services-menu">
                                <div className="service-tab active" data-service="consulting">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">AI consulting</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="poc">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">PoC delivery</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="mvp">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">MVP development</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="software">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">AI software development</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="model">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">AI model design and training</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="support">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">AI support, optimization, and audit</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Service Details */}
                        <div className="col-lg-7">
                            <div className="service-details-container">
                                {/* AI Consulting */}
                                <div className="service-detail active" id="consulting">
                                    <h3 className="service-detail-title">AI consulting</h3>
                                    <p className="service-detail-description">
                                        We deliver a tailored AI launch strategy, define a scalable, high-performance architecture
                                        and tech stack, and assess economic viability. Our services include expert guidance on
                                        model selection, security, compliance, and cost optimization, along with a detailed
                                        implementation roadmap.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request AI consulting</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* PoC Delivery */}
                                <div className="service-detail" id="poc">
                                    <h3 className="service-detail-title">PoC delivery</h3>
                                    <p className="service-detail-description">
                                        Transform your AI concepts into tangible proof-of-concept solutions. We rapidly prototype
                                        and validate your AI ideas, demonstrating feasibility and business value before full-scale
                                        development. Our PoC approach minimizes risk, validates assumptions, and provides clear
                                        insights into implementation requirements and expected ROI.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request PoC development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* MVP Development */}
                                <div className="service-detail" id="mvp">
                                    <h3 className="service-detail-title">MVP development</h3>
                                    <p className="service-detail-description">
                                        Launch your AI solution quickly with a Minimum Viable Product that delivers core
                                        functionality and value. We focus on essential features, rapid deployment, and iterative
                                        improvements based on real user feedback. Our MVP approach accelerates time-to-market,
                                        reduces development costs, and enables data-driven product evolution.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request MVP development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* AI Software Development */}
                                <div className="service-detail" id="software">
                                    <h3 className="service-detail-title">AI software development</h3>
                                    <p className="service-detail-description">
                                        Build robust, scalable, and production-ready AI applications tailored to your business
                                        needs. Our full-cycle development services cover architecture design, model integration,
                                        API development, UI/UX implementation, and deployment. We ensure your AI software is
                                        secure, maintainable, and delivers exceptional performance at scale.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request AI software development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* AI Model Design and Training */}
                                <div className="service-detail" id="model">
                                    <h3 className="service-detail-title">AI model design and training</h3>
                                    <p className="service-detail-description">
                                        Create custom AI models optimized for your specific use cases and data. We handle everything
                                        from data preparation and feature engineering to model architecture selection, training,
                                        fine-tuning, and validation. Our expertise spans computer vision, NLP, generative AI,
                                        predictive analytics, and more, ensuring optimal accuracy and performance.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request model development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* AI Support, Optimization, and Audit */}
                                <div className="service-detail" id="support">
                                    <h3 className="service-detail-title">AI support, optimization, and audit</h3>
                                    <p className="service-detail-description">
                                        Maximize the performance, efficiency, and reliability of your existing AI systems. Our
                                        comprehensive support services include continuous monitoring, performance optimization,
                                        model retraining, security audits, and compliance assessments. We identify bottlenecks,
                                        reduce operational costs, and ensure your AI solutions evolve with changing business needs.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request AI optimization</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* AI Capabilities Section */}
            <section className="ai-capabilities-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline-white">AI INNOVATION</span>
                                <h2 className="section-title-dark">AI Software and Capabilities CLOUD MIND X Specializes In</h2>
                                <p className="section-description-dark">
                                    With extensive expertise across <strong>30+ industries</strong>, CLOUD MIND X is a leading AI consulting and development company that delivers customized AI solutions tailored to the unique requirements of each business domain, including healthcare, banking, insurance, lending, investment, manufacturing, retail & ecommerce, advertising, education, and professional services.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {/* Generative AI */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="20" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="24" r="12" fill="#4187f7" opacity="0.2" />
                                        <path d="M24 12V24L30 30" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Generative AI</h4>
                                <p className="capability-description">
                                    Advanced AI systems that create original content including text, images, 3D models, audio, video, and source code based on custom parameters. Perfect for automated content generation, creative design support, rapid prototyping, and intelligent code development assistance.
                                </p>
                            </div>
                        </div>

                        {/* NLP Solutions */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="10" y="10" width="28" height="28" rx="4" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M18 20H30M18 24H30M18 28H26" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">NLP solutions</h4>
                                <p className="capability-description">
                                    Intelligent systems that comprehend, analyze, and produce human language for diverse applications including advanced text classification, sentiment analysis, named entity recognition, multilingual translation, and automated document summarization for enterprise efficiency.
                                </p>
                            </div>
                        </div>

                        {/* Conversational AI */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 32L18 26H36C37.1 26 38 25.1 38 24V12C38 10.9 37.1 10 36 10H12C10.9 10 10 10.9 10 12V30C10 31.1 10.9 32 12 32Z" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="18" cy="18" r="1.5" fill="#4187f7" />
                                        <circle cx="24" cy="18" r="1.5" fill="#4187f7" />
                                        <circle cx="30" cy="18" r="1.5" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Conversational AI</h4>
                                <p className="capability-description">
                                    Sophisticated chatbots and virtual assistants powered by machine learning that understand complex human language patterns and deliver natural, context-aware responses. Ideal for 24/7 customer support, intelligent digital assistants, and automated internal help desk operations.
                                </p>
                            </div>
                        </div>

                        {/* Speech Recognition */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="20" y="10" width="8" height="16" rx="4" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 26V32M24 32H18M24 32H30" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M16 20C16 24.4 19.6 28 24 28C28.4 28 32 24.4 32 20" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Speech recognition</h4>
                                <p className="capability-description">
                                    Cutting-edge software that accurately processes human speech audio inputs, enabling voice-activated commands and seamless human-like voice interactions. Transform spoken words into actionable insights and automated responses for enhanced user experiences.
                                </p>
                            </div>
                        </div>

                        {/* Agentic AI */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="18" r="6" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M14 36C14 30 18.5 26 24 26C29.5 26 34 30 34 36" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="24" cy="18" r="3" fill="#4187f7" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Agentic AI</h4>
                                <p className="capability-description">
                                    Next-generation autonomous AI systems designed to execute complex multi-step workflows and achieve strategic objectives. These intelligent agents make independent decisions, seamlessly interact with digital ecosystems, adapt to dynamic changes, and function with minimal human intervention.
                                </p>
                            </div>
                        </div>

                        {/* Predictive AI */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 32L16 24L22 28L30 16L38 22" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="38" cy="22" r="3" fill="#4187f7" />
                                        <rect x="8" y="8" width="32" height="32" rx="2" stroke="#4187f7" strokeWidth="2" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Predictive AI</h4>
                                <p className="capability-description">
                                    Powerful analytics software engineered for comprehensive data analysis, intelligent processing, and generating highly accurate forecasts on critical business variables. Delivers data-driven recommendations and optimal decision strategies to maximize business outcomes and competitive advantage.
                                </p>
                            </div>
                        </div>

                        {/* Business Automation */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="10" y="14" width="28" height="20" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M16 22L22 28L32 18" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="16" cy="16" r="2" fill="#4187f7" />
                                        <circle cx="24" cy="16" r="2" fill="#4187f7" />
                                        <circle cx="32" cy="16" r="2" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Business automation</h4>
                                <p className="capability-description">
                                    Enterprise-grade software leveraging advanced machine learning algorithms to streamline and automate intricate end-to-end business processes. Revolutionize operations with automated invoice processing, intelligent claims management, seamless customer onboarding, and workflow optimization.
                                </p>
                            </div>
                        </div>

                        {/* Computer Vision */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="14" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="24" r="8" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="24" r="3" fill="#4187f7" />
                                        <path d="M24 10V14M24 34V38M38 24H34M14 24H10" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Computer vision</h4>
                                <p className="capability-description">
                                    Advanced visual intelligence software that automatically extracts meaningful insights from images and videos, interpreting complex visual data and triggering custom actions based on detected patterns. Essential for facial recognition systems, automated quality control, security surveillance, and autonomous vehicle technology.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </>
    )
}

export default AIServices